import { render, staticRenderFns } from "./database.vue?vue&type=template&id=6fa3a665&lang=pug"
import script from "./database.vue?vue&type=script&lang=js"
export * from "./database.vue?vue&type=script&lang=js"
import style0 from "./database.vue?vue&type=style&index=0&id=6fa3a665&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports